// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TTqtD","tabsBox":"styles_tabsBox__1xZsg","createButton":"styles_createButton__17qgo"};